module.exports = __webpack_public_path__ + "h5/img/icon_04.3165d52a.png";